import React from "react";
import { trackEvent } from "src/utils/api/tracker";
import { captureException } from "src/utils/error";

interface Props {
  onErrorRender?:
    | React.ReactNode
    | ((error: Error, clearError: () => void) => React.ReactNode);
  children: React.ReactNode;
}

interface State {
  error: Error | null;
}

export default class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    captureException(error, undefined, errorInfo);

    // Track critical crashers separately in mixpanel to help differentiate
    // between background and foreground errors.
    trackEvent("OnBSOD");
  }

  override render() {
    const { children } = this.props;
    const { error } = this.state;

    if (error) {
      return null;
    }

    return children;
  }
}
